import utils from './utils/request.js';
import { getLocalI18nH5 } from './lang/index.js';
import EmapFlowCommentM from './components/mobile/emap-flow-comment-m.vue';
import EmapFlowEsignatureM from './components/mobile/emap-flow-esignature-m.vue';
import EmapFlowNextStepM from './components/mobile/emap-flow-next-step-m.vue';
import EmapFlowPickM from './components/mobile/emap-flow-pick-m.vue';
import EmapFlowStepsM from './components/mobile/emap-flow-steps-m.vue';
import EmapFlowToolbarM from './components/mobile/emap-flow-toolbar-m.vue';
import FooterButtons from './components/mobile/features/footer-buttons.vue';
import SecondVerification from './components/mobile/features/second-verification.vue';
import AddAssignee from './components/mobile/modals/add-assignee.vue';
import ChangeAssignee from './components/mobile/modals/change-assignee.vue';
import DelAssignee from './components/mobile/modals/del-assignee.vue';
import SealModal from './components/mobile/modals/seal-modal.vue';
const version = "2.0.0";
const description = "h5tag components for emapflow of mobile";
const author = "金智教育 wisedu";
const components = {
  EmapFlowCommentM,EmapFlowEsignatureM,EmapFlowNextStepM,EmapFlowPickM,EmapFlowStepsM,EmapFlowToolbarM,FooterButtons,SecondVerification,AddAssignee,ChangeAssignee,DelAssignee,SealModal
};
const install = function (Vue) {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    Vue.component(components[key].name, components[key]);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.prototype.$LocalH5 = getLocalI18nH5 //本地语言
  install(window.Vue);
}else{
  window.require(['vue'], function (Vue) {
    Vue.prototype.$LocalH5 = getLocalI18nH5 //本地语言
    install(Vue);
  });
}

export {utils, version, description, author}
export default Object.assign({}, { install }, components);import vant from 'vant';
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(vant)
  }else {
    window.require(['vue'], function (Vue) {
      Vue.use(vant)
    });
  }
  